import { useState } from 'react';
import UsageInfo from '../../components/UsageInfo';
import PageHeader from '../../components/PageHeader';

function Toggle({ aktif, onChange, label, desc }) {
  return (
    <label className="flex items-start gap-4 cursor-pointer group p-2 hover:bg-gray-50 rounded-2xl transition-colors duration-300">
      <div className="mt-1 flex-shrink-0">
        <div onClick={onChange}
          className={`relative w-12 h-7 rounded-full transition-colors duration-300 shadow-inner ${aktif ? 'bg-emerald-500 shadow-emerald-200' : 'bg-gray-300'}`}>
          <span className={`absolute top-1 left-1 w-5 h-5 bg-white rounded-full shadow-lg transition-transform duration-300 ${aktif ? 'translate-x-5' : 'translate-x-0'}`} />
        </div>
      </div>
      <div>
        <p className={`text-sm font-black uppercase tracking-tight transition-colors duration-300 ${aktif ? 'text-gray-800' : 'text-gray-400'}`}>{label}</p>
        {desc && <p className="text-[10px] font-bold text-gray-400 mt-1 uppercase tracking-widest">{desc}</p>}
      </div>
    </label>
  );
}

function Kart({ title, icon, children }) {
  return (
    <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden group hover:shadow-xl hover:shadow-blue-100/30 transition-[box-shadow,transform] duration-500 border-2 hover:border-blue-100">
      <div className="px-6 py-5 border-b border-gray-50 flex items-center justify-between bg-gray-50/30">
        <div className="flex items-center gap-3">
          <span className="text-xl group-hover:scale-125 transition-transform duration-500">{icon}</span>
          <h3 className="font-black text-gray-800 text-xs uppercase tracking-widest">{title}</h3>
        </div>
      </div>
      <div className="p-6 md:p-8 space-y-6">{children}</div>
    </div>
  );
}

const INP = "w-full border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 focus:outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-50 bg-white transition-all placeholder-gray-300 shadow-sm shadow-blue-50/20";

export default function WebSiteAyarlari() {
  const [kayit, setKayit] = useState(false);

  // Sanal Pos
  const [sanalPos, setSanalPos] = useState(false);
  const [onOdemePct, setOnOdemePct] = useState(15);

  // Rezervasyon formu ayarları
  const [kisiSayisiDevreDisi, setKisiSayisiDevreDisi] = useState(true);
  const [misafirZorunlu, setMisafirZorunlu] = useState(true);
  const [musaitlikTablosu, setMusaitlikTablosu] = useState(true);
  const [formKapali, setFormKapali] = useState(false);
  const [minGece, setMinGece] = useState(1);

  // IBAN & mesaj
  const [iban, setIban] = useState('TR00 0000 0000 0000 0000 0000 00');
  const [tesekkurMesaj, setTesekkurMesaj] = useState('Rezervasyonunuz başarıyla oluşturuldu. Bizi tercih ettiğiniz için teşekkürler!');

  // Genel bilgiler
  const [otelAdi, setOtelAdi] = useState('HOTELFLOW TEST OTEL');
  const [telefon, setTelefon] = useState('5336974911');
  const [email, setEmail] = useState('info@hotelflow.com');
  const [adres, setAdres] = useState('Konforlu Sokak No:123, Tatil Beldesi / Türkiye');
  const [checkInSaat, setCheckInSaat] = useState('14:00');
  const [checkOutSaat, setCheckOutSaat] = useState('12:00');

  function kaydet() {
    setKayit(true);
    setTimeout(() => setKayit(false), 2500);
  }

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50" style={{ animation: 'fadeIn 0.4s ease-out' }}>
      
      <PageHeader
        icon="🌐"
        iconColor="from-blue-600 to-indigo-700"
        iconShadow="shadow-blue-200"
        title="Web Site Ayarları"
        subtitle="Rezervasyon formu, ödeme ve site geneli ayarlar"
      >
        <div className="flex flex-wrap items-center gap-3">
          <a href="#" target="_blank" className="bg-white hover:bg-gray-50 text-blue-600 px-6 py-4 rounded-2xl text-[10px] font-black border-2 border-blue-50 shadow-sm transition-all uppercase tracking-widest flex items-center gap-2">
            🔗 Siteyi Görüntüle
          </a>
          <div className="bg-rose-50 text-rose-500 text-[9px] font-black px-4 py-4 rounded-2xl border-2 border-rose-100 shadow-sm shadow-rose-100/20 uppercase tracking-widest max-w-[150px] leading-tight text-center">
            ⚠️ Web site paketi aktif değil
          </div>
        </div>
      </PageHeader>

      <div className="space-y-6">
        {/* Rezervasyon formu yönlendirme - Dikkat Çeken Kart */}
        <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-[2.5rem] p-6 md:p-10 shadow-2xl shadow-emerald-200 relative overflow-hidden group cursor-pointer transition-[box-shadow,transform] duration-500 hover:scale-[1.01]" 
          onClick={() => { /* Navigasyon */ }}>
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-80 h-80 bg-white/10 rounded-full blur-3xl opacity-50 pointer-events-none group-hover:scale-110 transition-transform duration-700" style={{ transform: 'translateZ(0)', willChange: 'transform' }}></div>
          <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div className="flex items-center gap-6">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-3xl flex items-center justify-center text-4xl shadow-inner border border-white/30">📑</div>
              <div className="text-white">
                <h2 className="text-2xl font-black tracking-tight uppercase">Rezervasyon Formu Tasarımı</h2>
                <p className="text-emerald-50 text-[11px] font-black uppercase tracking-widest mt-1 opacity-80">Misafirlerinizin kullandığı rezervasyon sürecini özelleştirin</p>
              </div>
            </div>
            <button className="bg-white text-emerald-600 px-10 py-5 rounded-2xl text-xs font-black shadow-xl shadow-emerald-900/20 hover:scale-105 active:scale-95 transition-all uppercase tracking-widest">
              ÖNİZLEME VE DÜZENLE »
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Sol Kolon */}
          <div className="space-y-8">
            <Kart title="Otel Genel Bilgileri" icon="🏨">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Otel Ticari Adı *</label>
                  <input value={otelAdi} onChange={e => setOtelAdi(e.target.value.toUpperCase())} className={INP} />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">İletişim Telefonu</label>
                  <input value={telefon} onChange={e => setTelefon(e.target.value)} className={INP} placeholder="05__ ___ __ __" />
                </div>
              </div>
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Resmi E-Posta</label>
                <input value={email} onChange={e => setEmail(e.target.value)} className={INP} type="email" placeholder="iletisim@oteliniz.com" />
              </div>
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Konum / Adres</label>
                <textarea value={adres} onChange={e => setAdres(e.target.value)}
                  className={INP + ' resize-none min-h-[100px]'} rows={3} placeholder="Haritalarda ve faturalarda görünecek adres..." />
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Standard Check-in</label>
                  <input type="time" value={checkInSaat} onChange={e => setCheckInSaat(e.target.value)} className={INP} />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Standard Check-out</label>
                  <input type="time" value={checkOutSaat} onChange={e => setCheckOutSaat(e.target.value)} className={INP} />
                </div>
              </div>
            </Kart>

            <Kart title="Finansal Ödeme Ayarları" icon="💳">
              <div className="bg-indigo-50/50 rounded-[2rem] border-2 border-indigo-100 p-6">
                 <Toggle aktif={sanalPos} onChange={() => setSanalPos(p => !p)}
                   label="Sanal POS / Kredi Kartı ile Tahsilat"
                   desc="Web sitesinden online rezervasyon anında ödeme almayı aktifleştirir." />
              </div>
              
              <div className={`space-y-6 transition-all duration-500 ${!sanalPos ? 'opacity-30 pointer-events-none grayscale' : ''}`}>
                <div>
                    <div className="flex items-center justify-between mb-3 ml-1">
                      <label className="text-[10px] font-black text-gray-500 uppercase tracking-widest">Ön Ödeme (Garanti) Yüzdesi</label>
                      <span className="bg-indigo-600 text-white px-3 py-1 rounded-full text-[11px] font-black shadow-lg shadow-indigo-100">%{onOdemePct}</span>
                    </div>
                    <div className="relative h-10 flex items-center">
                       <input type="range" min={0} max={100} value={onOdemePct}
                        onChange={e => setOnOdemePct(+e.target.value)}
                        className="w-full h-2 bg-gray-100 rounded-lg appearance-none cursor-pointer accent-indigo-600" />
                    </div>
                </div>
              </div>

              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 ml-1">
                  Havale / EFT İçin Banka Bilgileri
                </label>
                <textarea value={iban} onChange={e => setIban(e.target.value)}
                  className={INP + ' resize-none min-h-[120px] font-mono text-xs'} rows={4}
                  placeholder="Banka x, Şube y, IBAN: TR..." />
                <p className="text-[9px] font-bold text-gray-300 mt-2 uppercase tracking-widest">Bu bilgiler ödeme adımı seçeneklerinde gösterilecektir.</p>
              </div>
            </Kart>
          </div>

          {/* Sağ Kolon */}
          <div className="space-y-8">
            <Kart title="Rezervasyon Formu Kuralları" icon="📋">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                 <div className="bg-blue-50/50 border-2 border-blue-100 rounded-[1.5rem] p-5">
                    <label className="text-[10px] font-black text-blue-700 uppercase tracking-widest block mb-3 leading-none">Minimum Gece Sayısı</label>
                    <div className="flex items-center justify-between">
                       <button onClick={() => setMinGece(m => Math.max(1, m - 1))} className="w-10 h-10 rounded-xl bg-white border-2 border-blue-100 text-blue-600 font-black hover:bg-blue-600 hover:text-white transition-all shadow-sm">－</button>
                       <span className="text-2xl font-black text-blue-800">{minGece}</span>
                       <button onClick={() => setMinGece(m => m + 1)} className="w-10 h-10 rounded-xl bg-white border-2 border-blue-100 text-blue-600 font-black hover:bg-blue-600 hover:text-white transition-all shadow-sm">＋</button>
                    </div>
                 </div>
                 <div className="bg-indigo-50/50 border-2 border-indigo-100 rounded-[1.5rem] p-5 flex items-center justify-center text-center">
                    <p className="text-[10px] font-bold text-indigo-400 uppercase leading-relaxed tracking-tighter">🏡 Konaklama Birimi (Villa/Apart) için kısıtlamalar buradan belirlenir.</p>
                 </div>
              </div>

              <div className="space-y-4 pt-2">
                <Toggle aktif={kisiSayisiDevreDisi} onChange={() => setKisiSayisiDevreDisi(p => !p)}
                  label="Kişi Sayısını Devre Dışı Bırak"
                  desc="Fiyatlandırmada sadece oda/gece bazlı sabit fiyat kullanılır." />
                <Toggle aktif={misafirZorunlu} onChange={() => setMisafirZorunlu(p => !p)}
                  label="Misafir Detaylarını Zorunlu Tut"
                  desc="Tüm konaklayacak misafirlerin kimlik bilgilerinin girilmesini bekler." />
                <Toggle aktif={musaitlikTablosu} onChange={() => setMusaitlikTablosu(p => !p)}
                  label="Tarih Bazlı Müsaitlik Takvimi"
                  desc="Formun başında müsaitlik durumunu takvim üzerinde listeler." />
              </div>
            </Kart>

            <Kart title="Sonuç Mesajı ve Sezon Durumu" icon="✉️">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1">Başarı Mesajı (Screen Content)</label>
                <textarea value={tesekkurMesaj} onChange={e => setTesekkurMesaj(e.target.value)}
                  className={INP + ' resize-none min-h-[100px]'} rows={3}
                  placeholder="Misafir rezervasyonu bitirdiğinde ne görmesini istersiniz?" />
                <p className="text-[9px] font-bold text-gray-300 mt-2 uppercase tracking-widest leading-relaxed">Başarılı checkout sonrası gösterilecek tebrik içeriğidir.</p>
              </div>

              <div className={`mt-8 p-6 rounded-[2rem] border-2 transition-all duration-500 ${formKapali ? 'bg-rose-50 border-rose-200 shadow-xl shadow-rose-100' : 'bg-gray-50 border-gray-100 opacity-60'}`}>
                <Toggle aktif={formKapali} onChange={() => setFormKapali(p => !p)}
                  label="Web Formunu Ziyaretlere Kapat"
                  desc="Sezon dışı veya bakım durumlarında formu tamamen gizler." />
                {formKapali && (
                  <div className="mt-4 flex items-center gap-3 text-rose-600 animate-pulse">
                    <span className="text-xl">⚠️</span>
                    <p className="text-[11px] font-black uppercase tracking-widest">Rezervasyon sistemi kapalı!</p>
                  </div>
                )}
              </div>
            </Kart>
          </div>
        </div>

        {/* Global Action Bar */}
        <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 border-b-8 border-b-blue-600">
          <div className="flex items-center gap-4">
             <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center text-xl">ℹ️</div>
             <div>
                <p className="text-[11px] font-black text-gray-800 uppercase tracking-tight leading-none mb-1">Değişiklikleri Kaydet</p>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Ayarlarınız buluta anında senkronize edilir.</p>
             </div>
          </div>
          <button onClick={kaydet}
            className={`w-full md:w-auto px-16 py-5 rounded-2xl text-sm font-black shadow-2xl transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest ${kayit ? 'bg-emerald-500 text-white shadow-emerald-100' : 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-blue-200 hover:from-blue-700 hover:to-indigo-800'}`}>
            {kayit ? '✅ AYARLAR KAYDEDİLDİ' : '💾 SİSTEMİ GÜNCELLE'}
          </button>
        </div>
      </div>

      <UsageInfo
        color="blue"
        description="Web Site Ayarları, tesisinizin dijital vitrinini ve online satış kanalını (rezervasyon motoru) kontrol ettiğiniz merkezdir. Buradan yapacağınız her değişiklik hem formun çalışma mantığını hem de görünümünü etkiler."
        scenarios={[
          { title: "Banka ve Sanal Pos", content: "Sanal pos aktif değilse misafirleriniz 'Havale/EFT' seçeneği ile rezervasyon yapabilir. İBAN bilgilerinizi eksiksiz girmeyi unutmayın." },
          { title: "Kişi Sayısı Kısıtlaması", content: "Eğer bir villayı veya odayı kaç kişi gelirse gelsin tek fiyattan satıyorsanız 'Kişi Sayısını Devre Dışı Bırak' seçeneği tam size göre." },
          { title: "Sezon Yönetimi", content: "Otelinizi tadilat veya sezon arası nedeniyle kapatıyorsanız, telefon trafiğini ve yanlış rezervasyonları önlemek için 'Formu Kapat' seçeneğini kullanın." }
        ]}
      />

      <style>{`
        @keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
        input[type="range"]::-webkit-slider-thumb { border-radius: 50%; width: 24px; height: 24px; background: #4f46e5; border: 4px solid white; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
      `}</style>
    </div>
  );
}